import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import logo from "../../images/email.png";
import * as Styled from "./styles";
import { hideHeader } from "../../actions/appStatus.actions";
import { getWebsiteUrl } from "../../utils/content";

const ConfirmationPageComponent = ({ hideHeader, match }) => {
  useEffect(() => window.scrollTo(0, 0), []);
  useEffect(() => hideHeader(), []);
  const { requestType } = match.params
  return (
    <div className="container app-container" style={{ textAlign: "center", marginTop: "60px" }}>
      <div className="row">
        <div className="col-12">
          <img
            src={logo}
            alt="Paper airplane"
            style={{ marginBottom: "30px", marginRight: "18px" }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Styled.PageHeading>Request Submitted</Styled.PageHeading>
          <p>
            We received your {requestType === "skip" ? "Consumer Loan Deferment" : "Real Estate Deferment"} request
            and we’re reviewing it now. You’ll get a confirmation email soon with more information
            about what to expect next. Please give us a call at 888.267.7200 if you have any further
            questions.
          </p>
          <Styled.TransparentBtn>
            <a href={getWebsiteUrl()} className="transparent-btn" style={{ color: "#00558C" }}>
              Laketrust.org
            </a>
          </Styled.TransparentBtn>
        </div>
      </div>
    </div>
  );
};

// Map global store to component props
const mapStateToProps = state => state;

// Hook up actions to component
const mapDispatchToProps = {
  hideHeader
};

//Connect to Redux store
const ConfirmationPage = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ConfirmationPageComponent)
);

export default ConfirmationPage;



// WEBPACK FOOTER //
// ./src/components/confirmation-page/component.js